const INITIAL_STATE = {
  formas: [],
  creditoDebito: [],
  metodosPagamentosParceiro: [],
  pagamentos: [],
  embarque: null
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'PAGAMENTO_FETCH_CREDITO_DEBITO':
      return { ...state, creditoDebito: action.payload }
    case 'PAGAMENTO_FETCH':
      return { ...state, formas: action.payload }
    case 'PAGAMENTO_REFETCH':
      return { ...state, formas: action.payload }
    case 'METODO_PAGAMENTO_PARCEIRO_FETCH':
      return { ...state, metodosPagamentosParceiro: action.payload }
    case 'METODO_PAGAMENTO_PARCEIRO':
      return { ...state, formas: action.payload }
    case 'RESERVA_PAGAMENTO_ADD':
      var novoPagamento = {
        valor: "",
        formaPagamento: { label: 'Selecione a forma de pagamento!', value: null },
        parcela: { label: '1X', value: 1 },
        local: ""
      }
      return { ...state, pagamentos: state.pagamentos.concat(novoPagamento) }
    case 'ACERTO_FINANCEIRO_PAGAMENTO_ADD':
      var novoPagamento = {
        valor: "",
        formaPagamento: { label: 'Selecione a forma de pagamento!', value: null },
        parcela: { label: '1X', value: 1 },
        local: ""
      }
      return { ...state, pagamentos: state.pagamentos.concat(novoPagamento) }
    case 'RESERVA_PAGAMENTO_CHANGE_VALOR':
      var copyPagamentos = [...state.pagamentos]
      var newValor = { ...copyPagamentos[action.index] }
      newValor.valor = action.payload
      copyPagamentos[action.index] = newValor

      return { ...state, pagamentos: copyPagamentos }

    case 'RESERVA_PAGAMENTO_CHANGE_LOCAL':
      var copyPagamentos = [...state.pagamentos]
      var newlocal = { ...copyPagamentos[action.index] }
      newlocal.local = action.payload
      copyPagamentos[action.index] = newlocal
      return { ...state, pagamentos: copyPagamentos }
    case 'RESERVA_PAGAMENTO_CHANGE_FORMA_PAGAMENTO':
      var copyPagamentos = [...state.pagamentos]
      var newformaPagamento = { ...copyPagamentos[action.index] }
      newformaPagamento.formaPagamento = action.payload
      copyPagamentos[action.index] = newformaPagamento

      return { ...state, pagamentos: copyPagamentos }
    case 'RESERVA_PAGAMENTO_CHANGE_PARCELA':
      var copyPagamentos = [...state.pagamentos]
      var newParcela = { ...copyPagamentos[action.index] }
      newParcela.parcela = action.payload
      copyPagamentos[action.index] = newParcela
      return { ...state, pagamentos: copyPagamentos }

    case 'PAGAMENTO_FORMA_LIMPAR_ARRAY_PAGAMENTOS':
      // Você pode adicionar um novo item ao array aqui
      return { ...state, pagamentos: action.payload }

    case 'EDITAR_PAGAMENTO':
      const pagamentosDoBackEnd = action.payload

      var novosPagamentos = pagamentosDoBackEnd.map((pagamento) => {
        return {
          valor: pagamento.pag_valor,
          formaPagamento: { label: pagamento.forma.pag_nome, value: pagamento.forma.pag_id },

          parcela: pagamento.parcela !== null ? { value: pagamento?.parcela?.par_id, label: pagamento?.parcela?.par_nome } : { label: '1X', value: 1 },
          local: pagamento.pag_local
        }
      })
      return { ...state, pagamentos: novosPagamentos }
    case 'RESERVA_REMOVER_LINHA_FORMA_PAGAMENTO':
      var novosPagamentos = state.pagamentos.filter((pagamento, index) => index !== action.index)
      console.log(novosPagamentos)

      return { ...state, pagamentos: novosPagamentos }
    default:
      return state
  }
}